module.exports = __webpack_public_path__ + "static/img/raspberry_th.2731808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/raspberry_th.png
// module id = lvHT
// module chunks = 0